module.exports = __webpack_public_path__ + "media/reskin-images/onboarding--notes-1-7744ac62.png";